import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useConsultorioBranding } from '../../context/ConsultorioBrandingContext';

function getInitials(name) {
  const parts = String(name || 'C')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
  }
  const one = parts[0] || 'C';
  return one.slice(0, 2).toUpperCase();
}

function BrandName({ name, compact }) {
  const parts = useMemo(
    () => String(name || 'Consultorio').trim().split(/\s+/).filter(Boolean),
    [name]
  );

  if (parts.length <= 1) {
    return <span className="csl-brand-name">{parts[0] || name}</span>;
  }

  const lead = parts[0];
  const tail = parts.slice(1).join(' ');

  return (
    <span
      className={[
        'csl-brand-name',
        'csl-brand-name--wordmark',
        compact ? 'csl-brand-name--wordmark-compact' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="csl-brand-name__lead">{lead}</span>
      <span className="csl-brand-name__tail">{tail}</span>
    </span>
  );
}

/**
 * Logo del consultorio o nombre en la barra superior (compact) o vistas de configuración.
 */
export default function ConsultorioBrand({
  className = '',
  compact = false,
  asLink = true,
  variant = 'auto',
}) {
  const { displayName, logoUrl, loading } = useConsultorioBranding();
  const initials = useMemo(() => getInitials(displayName), [displayName]);
  const showFull = variant === 'full';

  const inner = (
    <div
      className={[
        'csl-brand',
        logoUrl ? 'csl-brand--logo' : 'csl-brand--text',
        compact ? 'csl-brand--compact' : '',
        showFull ? 'csl-brand--full' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      title={displayName}
    >
      {loading ? (
        <div className="csl-brand-skeleton" aria-hidden />
      ) : logoUrl ? (
        <img src={logoUrl} alt={displayName} className="csl-brand-logo" loading="lazy" />
      ) : (
        <>
          <div className="csl-brand-monogram" aria-hidden>
            {initials}
          </div>
          <div className="csl-brand-copy">
            <BrandName name={displayName} compact={compact || showFull} />
          </div>
        </>
      )}
    </div>
  );

  if (!asLink) return inner;

  return (
    <Link to="/consultorio" className="csl-brand-link" title={displayName}>
      {inner}
    </Link>
  );
}
